import { Button, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { SectionCard } from "components/SectionCard/SectionCard";
import { IDevice } from "interfaces/device.interface";

import { DeviceRow } from "./DeviceRow";

type SubjectDevicesProps = {
  zoneId: string;
  devices: IDevice[];
};

export function SubjectDevices({ zoneId, devices }: SubjectDevicesProps) {
  const { t } = useTranslation();

  if (!devices?.length) {
    return (
      <SectionCard title={t("Devices")}>
        <Typography>{t("no_device_assigned_to_this_subject_yet")}</Typography>
        <Button
          component={Link}
          to={`/administration/zones/${zoneId}/devices`}
          variant={"text"}
        >
          {t("see_devices_in_this_zone")}
        </Button>
      </SectionCard>
    );
  }

  return (
    <SectionCard title={t("Devices")}>
      {devices.map((device) => (
        <DeviceRow key={device.serial_number} device={device} />
      ))}
    </SectionCard>
  );
}
